import React from "react";

const ChrAsterisk = () => {
  return (
    <span className='text-critical pl-1'>*</span>
  );
};

export default ChrAsterisk;
